module.exports = __webpack_public_path__ + "static/media/vibration.be1d9545.png";